module.exports = __webpack_public_path__ + "static/com1-alt-0b28cab23bc6cb9a9eb6475642f215bf.jpg";